<div class="auth-page">
  <div class="auth-card">
    <h1 class="auth-heading">Change your password</h1>
    <p class="auth-subtitle">
      Forgot password? <a class="text-primary hover:underline cursor-pointer font-medium"
        routerLink="/auth/forgot-password">Click here</a> to reset.
    </p>

    <form name="changePasswordForm" #form="ngForm" (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-4">
        <p-password [(ngModel)]="oldpassword" [toggleMask]="true" required name="oldpassword" placeholder="Old password"
          [feedback]="false" styleClass="w-full"></p-password>
        <p-password [(ngModel)]="newpassword" [toggleMask]="true" required name="newpassword" placeholder="New password"
          strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_\W])(?=.{8,})" styleClass="w-full"></p-password>
        <p-password [(ngModel)]="conpassword" [toggleMask]="true" required name="conpassword"
          placeholder="Confirm password" [feedback]="false" styleClass="w-full"></p-password>

        <prox-password-rules [password]="newpassword" [confirm]="conpassword"></prox-password-rules>

        <div class="flex gap-2 mt-2">
          <button pButton pRipple label="Cancel" type="button" class="flex-auto p-button-outlined" [routerLink]="['/']"></button>
          <button pButton pRipple label="Submit" type="submit" class="flex-auto"
            [disabled]="form.invalid || (conpassword !== newpassword) || !passwordMeetsRules(newpassword) || !!success"
            [loading]="working"></button>
        </div>

        @if (error) {
          <p class="text-red-500 text-center mt-3 mb-0">{{error}}</p>
        }
        @if (success) {
          <p class="text-green-500 text-center mt-3 mb-0">{{success}}</p>
        }
      </div>
    </form>

    <div class="auth-divider mt-6 mb-4">or</div>

    <p class="text-center text-sm text-gray-600 mb-0">
      A problem? <a routerLink="/auth/contact-us" class="text-primary font-medium hover:underline">Click here</a> and let
      us help you.
    </p>
  </div>
</div>
